import InputBox from "../../common/interactive/InputBox"
import CustomSelect from "../../common/interactive/CustomSelect"
import DatepickerWithLabel from "../../common/interactive/DatepickerWithLabel"
import RadioField from "../../common/interactive/RadioField"
import CheckboxCell from "../../common/interactive/CheckboxCell"
import TextareaBox from "../../common/interactive/TextareaBox"
import { useState } from "react"
import { formatSSN } from "../../../lib/script"

export default function FormField({label, required, children, type, value, optionsData, name, isDisabled, rtlDrawer, isSSN, format, hasAction}) {
    const [currentValue, setCurrentValue] = useState(isSSN ? formatSSN(value) : value ? value : '')

    function changeValueHandler(value) {
        setCurrentValue(value.data.value)
    }

    function actionHandler(value) {
        if (hasAction) {
            hasAction(value)
        }
    }
    
    return <>
        {type == 'input' && <InputBox label={label} name={name} required={required} currentValue={currentValue} action={changeValueHandler} isNotModifiable={isDisabled} redBorderFlag={!currentValue || currentValue == ''} format={format}/>}
        {type == 'select' && <CustomSelect label={label} name={name} required={required} optionsData={optionsData} preSelectedValue={currentValue} rtlDrawer={rtlDrawer} action={changeValueHandler} isDisabled={isDisabled} borderRed={!currentValue || currentValue == ''} hasRemove={true}/>}
        {type == 'date' && <DatepickerWithLabel label={label} name={name} required={required} defaultDate={currentValue} action={actionHandler} disabled={isDisabled} borderRed={!currentValue || currentValue == ''}/>}
        {type == 'radio' && <RadioField label={label} name={name} required={required} fields={optionsData} defaultChecked={currentValue} action={changeValueHandler} isDisabled={isDisabled} redBorderFlag={!currentValue || currentValue == ''}/>}
        {type == 'checkbox' && <CheckboxCell label={label} name={name} required={required} checked={currentValue} action={actionHandler} isDisabled={isDisabled} redBorderFlag={!currentValue || currentValue == ''}/>}
        {type == 'textarea' && <TextareaBox label={label} name={name} required={required} currentValue={currentValue} action={changeValueHandler} isNotModifiable={isDisabled} redBorderFlag={!currentValue || currentValue == ''}/>}
    </>
}